import Fluxible from 'vendor/cnpm/fluxible.v0-4/index';

import NaptimeStore from 'bundles/naptimejs/stores/NaptimeStore';
import ApplicationStore from 'bundles/ssr/stores/ApplicationStore';

import 'css!bundles/global-styles/global-element-styles';
// remove the grid import once all bt3-container, bt3-row, and bt3-col classes are removed from this bundle
import 'css!bundles/premium-certificate/__styles__/grid';

import component from './routes';

export type Stores = {
  ApplicationStore: ApplicationStore;
  NaptimeStore: NaptimeStore;
};

const appEnv = new Fluxible({
  component,
});

appEnv.registerStore(ApplicationStore);
appEnv.registerStore(NaptimeStore);

export default appEnv;
